const e2eAttributes = {
  rails: {
    // These are used on the Rails side of the application, before modifying them, please check they're not referenced anywhere
    fsjs: {
      selectStoreOwnerRole: "select-store-owner-role",
    },
    fsEmbed: {
      selectStoreOwnerRole: "select-store-owner-role",
      selectSubPractitionerRole: "select-sub-practitioner-role",
      selectClerkRole: "select-clerk-role",
    },
    athena: {
      selectStoreOwnerRole: "select-store-owner-role",
      selectSubPractitionerRole: "select-sub-practitioner-role",
      selectClerkRole: "select-clerk-role",
      removePractitionerLink: "remove-practitioner-link",
      removePatientLink: "remove-patient-link",
    },
    fsjsTesterLink: "fsjs-tester-link",
    retailOrders: "retail-orders-link",
    wholesaleOrders: "wholesale-orders-link",
    mainMenu: "main-menu",
    clinicMenuLink: "main-menu-clinic",
    engineeringMenuLink: "main-menu-engineering",
    orderSearch: "admin-order-search",
    userDropdown: "admin-user-link",
    signOut: "admin-user-sign-out-link",
    navSearch: "nav-search",
    impersonateMenu: "impersonate-link",
    impersonateDemoStoreLink: "impersonate-link-practitioner-fullscript",
    impersonateDemoClerkLink: "impersonate-link-clerk-fullscript",
    impersonateDemoPatientLink: "impersonate-link-patient-fullscript",
    adminDashboard: "admin-dashboard",
    storePage: {
      editModality: "edit-modality",
      modalityDropdown: "modality-dropdown",
      modalitySubmit: "modality-submit",
      rewardsLink: "rewards-link",
    },
  },
  admin: {
    impersonateModalLink: "impersonation-modal-link",
    reasonList: "reason-list",
    impersonateSubmitButton: "impersonate-submit-button",
  },
  practitionerHeader: {
    accountSettings: "practitioner_account_settings",
    dropdownLinkSignOut: "dropdownlink_signout",
    staffSettings: "staff-settings-link",
    wholesalePolicies: "wholesale-policies-link",
    practitionerName: "practitioner-name",
  },
  closeModalButton: "close-modal-button",
  searchProducts: "search-products",
  typeaheadResults: "typeahead-results",
  filtersButton: "filters-button",
  brandsFilter: "brands-filter",
  availabilityFilter: "availability-filter",
  aviarySkeleton: "aviary-skeleton",
  productName: (name: string) => `product-name-${name}`,
  attachment: "attachment",
  lexicalEditorContentEditable: "lexical-editor-content-editable",
  confirmModalPrimaryButton: "confirm-modal-primary-button",
  viewCartButton: "view-cart-button",
  addProductToCart: "add-product-to-cart",
  msrp: "msrp",
  filterByBrand: (name: string) => `${name} filter`,
  inStockFilter: "in-stock-filter",
  buildPlan: "build-plan",
  buildPlanDropdown: "build-plan-dropdown",
  buildPlanDropdownSupplements: "build-plan-dropdown-supplements",
  buildPlanDropdownTemplate: "build-plan-dropdown-template",
  buildPlanDropdownLabs: "build-plan-dropdown-labs",
  buildPlanDropdownJourney: "build-plan-dropdown-journey",
  buildPlanDropdownAssist: "build-plan-dropdown-assist",
  goToPDP: "go-to-pdp",
  patientProductCard: "patient-product-card",
  cart: {
    continueToCheckout: "continue-to-checkout",
    totalPrice: "cart-total-price",
    subtotalNew: "cart-subtotal-new",
    shipping: "cart-shipping",
    taxes: "cart-taxes",
  },
  emptyState: "empty-state",
  officeSignUp: {
    password: "office-sign-up-password",
    button: "office-sign-up-button",
    modal: "office-sign-up-modal",
  },
  paymentSettings: {
    streetAddressSuggestionContainer: "street-address-suggestions-container",
    streetAddressSuggestion: "street-address-suggestion",
    businessType: "business-type",
    businessName: "business-name",
    employerId: "employer-id",
    ssn: "ssn",
    routingNumber: "routing-number",
    accountNumber: "account-number",
    accountHolder: "account-holder",
    streetAddress: "street-address",
  },
  login: {
    oneTimeCodeInput: "one-time-passcode",
  },
  form: {
    email: "email",
    password: "password",
  },
  search: {
    clearSearchButton: "clear-search-button",
  },
} as const;

export { e2eAttributes };
